import { searchParametersActions } from 'features/searchResultsFacets';
import Select from '@components/select';
import { store, store$ } from '@redux/store';
import { distinctUntilChanged, map } from 'rxjs';
import { selectStories } from '../redux/selectors';

const select = document.querySelector('[data-stories-filter]');
const stories$ = new Select(select).getObservable();
const setValue = (value) => {
  select.value = value || 0;
};

stories$.subscribe((value) => {
  store.dispatch(searchParametersActions.fetchStories(value));
});

store$.pipe(map(selectStories), distinctUntilChanged()).subscribe(setValue);
